<template>
    <div>
               

        <v-row>
            <v-col class="py-2">
                <textFieldForm 
                    @valueChange="(v) => {values.private_key_password = v; delete serverErrors.private_key_password}" 
                    :valueInput="values.private_key_password" 
                    :rule="[]" 
                    label="Contraseña llave FIEL"
                    :errorMessages="serverErrors.private_key_password"
                ></textFieldForm>
            </v-col>
        </v-row>

        

        <v-row>
            <v-col class="py-2">
                <fileInputForm
                    
                    label="Archivo .key"
                    :multiple="false"
                    :valueInput="values.private_key"
                    :url="''"
                    :rule="[]"
                    @valueChange="(v) => {values.private_key = v; delete serverErrors.private_key}"
                    :errorMessages="serverErrors.private_key"
                    
                ></fileInputForm>
            </v-col>
        </v-row>


           <v-row>
            <v-col class="py-2">
                <fileInputForm
                    
                    label="Archivo .cer"
                    :multiple="false"
                    :valueInput="values.certificate"
                    :url="''"
                    :rule="[]"
                    @valueChange="(v) => {values.certificate = v; delete serverErrors.certificate}"
                    :errorMessages="serverErrors.certificate"
                    
                ></fileInputForm>
            </v-col>
        </v-row>



                
                
                

    </div>
</template>

<script>
/* eslint-disable */
export default {
    props: ['values', 'serverErrors', 'edit'],
   
    data(){
        return {
           
            rules: {
				required: [
					v => !!v || 'El campo requerido'
				],
				
            },
          
        }
    },
   
    mounted(){
    },
    methods: {
       
       
    }
}
</script>

<style>

</style>